export const AUTO_FIT_MIN_WIDTH_PX = 50;
export const AUTO_FIT_MAX_WIDTH_PX = 960;
export const AUTO_FIT_SLACK_PX = 8;
export const AUTO_FIT_HEADER_SORT_GUTTER_PX = 28;

export const clampAutoFitWidth = (width: number): number =>
    Math.min(AUTO_FIT_MAX_WIDTH_PX, Math.max(AUTO_FIT_MIN_WIDTH_PX, Math.ceil(width)));

const measureRenderedTextWidth = (text: string, sampleEl: HTMLElement): number => {
    if (!text) return 0;
    const style = getComputedStyle(sampleEl);
    const probe = document.createElement('span');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = [
        'position:absolute',
        'left:-9999px',
        'top:0',
        'white-space:nowrap',
        'pointer-events:none',
        `font:${style.font}`,
        `letter-spacing:${style.letterSpacing}`,
        `text-transform:${style.textTransform}`,
    ].join(';');
    probe.textContent = text;
    document.body.appendChild(probe);
    let width = probe.getBoundingClientRect().width || probe.offsetWidth;
    probe.remove();
    if (width === 0) {
        const fontSize = parseFloat(style.fontSize) || 14;
        width = text.length * fontSize * 0.6;
    }
    return width;
};

const extraNonTextWidth = (cell: HTMLElement): number => {
    let extra = 0;
    cell.querySelectorAll('img, svg').forEach((node) => {
        extra += (node as HTMLElement).getBoundingClientRect().width;
    });
    return extra;
};

/**
 * Measure the width needed to show the full header and visible cell text
 * for one column. Used by the Items / Catalog hit list so double-clicking
 * a column's right resize border matches the legacy ui-grid auto-fit.
 */
export const measureColumnAutoFitWidth = (tableEl: HTMLElement, columnId: string): number => {
    const cells = tableEl.querySelectorAll<HTMLElement>(
        `[data-column-id="${CSS.escape(columnId)}"]`,
    );
    if (cells.length === 0) {
        return AUTO_FIT_MIN_WIDTH_PX;
    }

    let maxWidth = 0;
    cells.forEach((cell) => {
        const style = getComputedStyle(cell);
        const pad = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
        const text = (cell.innerText || cell.textContent || '').replace(/\s+/g, ' ').trim();
        const content = measureRenderedTextWidth(text, cell) + extraNonTextWidth(cell);
        const gutter = cell.tagName === 'TH' ? AUTO_FIT_HEADER_SORT_GUTTER_PX : 0;
        maxWidth = Math.max(maxWidth, content + pad + gutter);
    });

    return clampAutoFitWidth(maxWidth + AUTO_FIT_SLACK_PX);
};
